import { render } from "./GlobalGiftSendWindow.vue?vue&type=template&id=048c56d7&scoped=true"
import script from "./GlobalGiftSendWindow.vue?vue&type=script&lang=js"
export * from "./GlobalGiftSendWindow.vue?vue&type=script&lang=js"

import "./GlobalGiftSendWindow.vue?vue&type=style&index=0&id=048c56d7&lang=scss&scoped=true"

import exportComponent from "/Users/apple/Documents/xxiwant/lovestory/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-048c56d7"]])

export default __exports__